import React, { useState } from "react"
import { EquifaxCollection } from "../../equifax-credit-report"
import { yyyymmdd } from "../../date-utils"
import { CodedDescriptor } from "./bankruptcies"

type CollectionsProps = {
  collections: EquifaxCollection[]
}

const Collections = ({ collections }: CollectionsProps) => {
  return (
    <div>
      <h5>Collections ({collections.length})</h5>

      {collections.length ? <table className="table">
        <thead>
          <tr>
            <th>Delinquency</th>
            <th>Balance</th>
            <th>Orig Amt</th>
            <th>Customer no</th>
            <th>Classification</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {collections.map((c, i) => <tr key={i} title={JSON.stringify(c, null, ' ')}>
            <td>{yyyymmdd(c.dateOfFirstDelinquency)}</td>
            <td>{c.balance}</td>
            <td>{c.originalAmount}</td>
            <td>{c.customerNumber}</td>
            <td><CodedDescriptor {...c.creditorClassificationCode} /></td>
            <td><CodedDescriptor {...c.statusCode} /></td>
          </tr>)}
        </tbody>
      </table> : null}
    </div>
  )
}

export default Collections